<p style="text-align: center; font-size: 20px">Please select a scope before performing a search.</p>
